import React from 'react';

const NoData = ({ working, runAI }) => {
  return (
    <>
      <div className="middle">
        <h3>BuzzIQ Summary</h3>
        { !working && <span className="-small">Get BuzzIQ Summary for all items</span>}
        { working && <span className="-small">Working on a summary. May need some time...</span>}
      </div>

      { !working &&
        <button
          type="button"
          className="button run-button"
          onClick={ runAI }
        >
          Run
        </button>
      }
    </>
  );
};

export default NoData;
